import { render, staticRenderFns } from "./WidgetHealthCareVisa.vue?vue&type=template&id=5dc29e7b&scoped=true&lang=pug"
import script from "./WidgetHealthCareVisa.vue?vue&type=script&lang=ts"
export * from "./WidgetHealthCareVisa.vue?vue&type=script&lang=ts"
import style0 from "./WidgetHealthCareVisa.vue?vue&type=style&index=0&id=5dc29e7b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc29e7b",
  null
  
)

export default component.exports